export function Password(password: string, confirmation: string = '') {
  const isEmpty = hasNoValue(password);
  const isValid = validatePassword(password);
  const isConfirmed = confirmPassword(password, confirmation);

  return {
    isEmpty,
    isValid,
    isConfirmed,
  };
}

function hasNoValue(value: string): boolean {
  return !value || value.trim() === '';
}

function validatePassword(password: string): boolean {
  if (hasNoValue(password)) return false;

  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecial = /[^a-zA-Z0-9]/.test(password);
  const isCorrectLength = password.length >= 8 && password.length <= 16;

  return (
    hasLowercase &&
    hasUppercase &&
    hasNumber &&
    hasSpecial &&
    isCorrectLength
  );
}

function confirmPassword(password: string, confirmation: string): boolean {
  return password === confirmation && !hasNoValue(password);
}

